import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface GenVideoUrlModel extends BaseModel {
  variables?: { [key: string]: string } | GenVideoUrlVariables;
}

export interface GenVideoUrlVariables {
  Link: string;
}

export class GenVideoUrlInitVariables implements GenVideoUrlVariables {
  Link = '';
}

export class GenVideoUrlInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new GenVideoUrlInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
